import { FormComponent } from "../common/Form";

type SaveErrorProps = {
  errorMessage: boolean;
};

const SaveError = (props: SaveErrorProps) => <FormComponent.BaseSaveError entity={"Integration"} {...props} />;

export { SaveError };
